export interface Manga {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  category: 'korean' | 'japanese' | 'chinese';
  categoryLabel: string;
  rating: number;
  ratingCount: number;
  tags: string[];
  status: '连载中' | '已完结';
  description: string;
  updatedAt: string;
  chapters: Chapter[];
  views: number;
  collects: number;
  isHot: boolean;
  isNew: boolean;
}

export interface Chapter {
  id: string;
  title: string;
  index: number;
  updatedAt: string;
}

export const categories = [
  { slug: 'korean', label: '韩漫', description: '韩国漫画精选，浪漫剧情与精美画风的完美结合', bgUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20Korean%20manhwa%20genre%20category%20background%20with%20soft%20elegant%20pastel%20colors%20minimal%20art%20decorative%20elements%20gentle%20gradient%20subtle%20ornamental%20design%20editorial%20illustration&width=800&height=400&seq=cat-bg-korean&orientation=landscape' },
  { slug: 'japanese', label: '日漫', description: '经典日系漫画，多元题材满足不同阅读偏好', bgUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20Japanese%20manga%20genre%20category%20background%20with%20soft%20elegant%20pastel%20colors%20minimal%20art%20decorative%20elements%20gentle%20gradient%20subtle%20ornamental%20design%20editorial%20illustration&width=800&height=400&seq=cat-bg-japanese&orientation=landscape' },
  { slug: 'chinese', label: '国漫', description: '国产原创漫画，国风美学与创新故事的碰撞', bgUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20Chinese%20manhua%20genre%20category%20background%20with%20soft%20elegant%20pastel%20colors%20minimal%20art%20decorative%20elements%20gentle%20gradient%20subtle%20ornamental%20design%20editorial%20illustration&width=800&height=400&seq=cat-bg-chinese&orientation=landscape' },
];

export const mangaList: Manga[] = [
  {
    id: 'my-fair-footman',
    title: '我的俊俏侍从',
    author: '春日井奈',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20romantic%20manga%20cover%20featuring%20elegant%20handsome%20male%20servant%20in%20historical%20fantasy%20setting%20with%20soft%20warm%20lighting%20floral%20decorations%20feminine%20aesthetic%20pastel%20tones%20editorial%20illustration&width=600&height=800&seq=manga-cover-mff&orientation=portrait',
    category: 'korean',
    categoryLabel: '韩漫',
    rating: 9.7,
    ratingCount: 12580,
    tags: ['恋爱', '宫廷', '逆袭'],
    status: '连载中',
    description: '身为伯爵家千金的艾琳娜，从未想过自己会爱上家中的侍从。那个总是沉默寡言、却在她每次危难时挺身而出的男人，究竟隐藏着怎样的秘密？当身份与爱情交错，她该如何抉择？一段跨越阶级的浪漫宫廷恋爱故事就此展开。',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch1', title: '第1话 命运的相遇', index: 1, updatedAt: '2026-08-04' },
      { id: 'ch2', title: '第2话 隐秘的心意', index: 2, updatedAt: '2026-08-02' },
      { id: 'ch3', title: '第3话 舞会之夜', index: 3, updatedAt: '2026-07-30' },
      { id: 'ch4', title: '第4话 暴风雨前夕', index: 4, updatedAt: '2026-07-28' },
      { id: 'ch5', title: '第5话 告白', index: 5, updatedAt: '2026-07-25' },
      { id: 'ch6', title: '第6话 身世之谜', index: 6, updatedAt: '2026-07-22' },
      { id: 'ch7', title: '第7话 王室的召唤', index: 7, updatedAt: '2026-07-20' },
      { id: 'ch8', title: '第8话 抉择', index: 8, updatedAt: '2026-07-18' },
    ],
    views: 125600,
    collects: 45230,
    isHot: true,
    isNew: false,
  },
  {
    id: 'empress-return',
    title: '女帝归来',
    author: '林月瑶',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20manga%20cover%20featuring%20elegant%20empress%20in%20flowing%20red%20hanfu%20traditional%20chinese%20palace%20background%20cherry%20blossoms%20dramatic%20pose%20regal%20aesthetic%20editorial%20illustration%20with%20soft%20lighting%20warm%20tones&width=600&height=800&seq=manga-cover-er&orientation=portrait',
    category: 'chinese',
    categoryLabel: '国漫',
    rating: 9.5,
    ratingCount: 18920,
    tags: ['古风', '逆袭', '权谋'],
    status: '连载中',
    description: '前世被最信任的人背叛，含恨而终。重生归来，她不再是谁的棋子。手握前世记忆，步步为营，她要在这一世成为真正的女帝！宫闱权谋、爱恨交织，且看她如何扭转乾坤。',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch1', title: '第1话 重生', index: 1, updatedAt: '2026-08-03' },
      { id: 'ch2', title: '第2话 布局', index: 2, updatedAt: '2026-08-01' },
      { id: 'ch3', title: '第3话 科举风云', index: 3, updatedAt: '2026-07-29' },
      { id: 'ch4', title: '第4话 暗流涌动', index: 4, updatedAt: '2026-07-27' },
      { id: 'ch5', title: '第5话 朝堂之争', index: 5, updatedAt: '2026-07-24' },
      { id: 'ch6', title: '第6话 棋逢对手', index: 6, updatedAt: '2026-07-21' },
    ],
    views: 234500,
    collects: 89200,
    isHot: true,
    isNew: true,
  },
  {
    id: 'sakura-promise',
    title: '樱花树下的约定',
    author: '樱井美咲',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20romantic%20manga%20cover%20two%20characters%20under%20blooming%20cherry%20blossom%20tree%20spring%20season%20soft%20pink%20petals%20falling%20school%20uniforms%20emotional%20scene%20dreamy%20lighting%20editorial%20illustration%20with%20warm%20pastel%20tones&width=600&height=800&seq=manga-cover-sp&orientation=portrait',
    category: 'japanese',
    categoryLabel: '日漫',
    rating: 9.6,
    ratingCount: 9870,
    tags: ['校园', '纯爱', '青春'],
    status: '已完结',
    description: '高中最后一年，她在樱花树下遇到了那个改变她一生的人。从青涩到成熟，从校园到社会，他们一起经历了太多。但毕业季的来临，是否意味着这段感情的终结？一段温暖治愈的纯爱故事。',
    updatedAt: '2026-07-15',
    chapters: [
      { id: 'ch1', title: '第1话 樱花盛开的季节', index: 1, updatedAt: '2026-07-15' },
      { id: 'ch2', title: '第2话 图书馆的秘密', index: 2, updatedAt: '2026-07-10' },
      { id: 'ch3', title: '第3话 夏日的烟火', index: 3, updatedAt: '2026-07-05' },
      { id: 'ch4', title: '第4话 文化祭', index: 4, updatedAt: '2026-06-28' },
      { id: 'ch5', title: '第5话 圣诞节的礼物', index: 5, updatedAt: '2026-06-20' },
      { id: 'ch6', title: '第6话 毕业旅行', index: 6, updatedAt: '2026-06-12' },
      { id: 'ch7', title: '第7话 最后的情书', index: 7, updatedAt: '2026-06-05' },
      { id: 'ch8', title: '第8话 樱花树下的约定（终章）', index: 8, updatedAt: '2026-05-28' },
    ],
    views: 89200,
    collects: 34100,
    isHot: false,
    isNew: false,
  },
  {
    id: 'star-sea-romance',
    title: '星辰大海都是你',
    author: '星河',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20fantasy%20romance%20manga%20cover%20featuring%20celestial%20starry%20night%20sky%20ocean%20waves%20lovers%20silhouette%20magical%20glowing%20atmosphere%20ethereal%20beauty%20dreamy%20cosmic%20theme%20editorial%20illustration%20with%20deep%20blue%20and%20gold%20tones&width=600&height=800&seq=manga-cover-ssr&orientation=portrait',
    category: 'chinese',
    categoryLabel: '国漫',
    rating: 9.4,
    ratingCount: 15670,
    tags: ['奇幻', '恋爱', '冒险'],
    status: '连载中',
    description: '她是天上的星辰，他是海中的浪花。本该永不相交的两人，却因为一场意外相遇了。为了她，他愿逆流而上；为了他，她愿坠落凡尘。一段跨越天与海的奇幻爱情故事。',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch1', title: '第1话 星辰坠海', index: 1, updatedAt: '2026-08-02' },
      { id: 'ch2', title: '第2话 深海秘境', index: 2, updatedAt: '2026-07-30' },
      { id: 'ch3', title: '第3话 鲛人之歌', index: 3, updatedAt: '2026-07-27' },
      { id: 'ch4', title: '第4话 月下盟约', index: 4, updatedAt: '2026-07-24' },
      { id: 'ch5', title: '第5话 风暴来临', index: 5, updatedAt: '2026-07-21' },
    ],
    views: 189300,
    collects: 67200,
    isHot: true,
    isNew: false,
  },
  {
    id: 'boss-secret',
    title: '社长大人是甜心',
    author: '朴美娜',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20romantic%20comedy%20manga%20cover%20featuring%20handsome%20CEO%20male%20lead%20in%20modern%20office%20setting%20with%20female%20protagonist%20playful%20expression%20chic%20fashion%20warm%20lighting%20contemporary%20Korean%20manhwa%20style%20editorial%20illustration%20soft%20colors&width=600&height=800&seq=manga-cover-bs&orientation=portrait',
    category: 'korean',
    categoryLabel: '韩漫',
    rating: 9.3,
    ratingCount: 22340,
    tags: ['职场', '甜宠', '喜剧'],
    status: '连载中',
    description: '新入职的小职员林小艺，意外发现冷面上司竟然是一个超级暖男？白天是雷厉风行的社长大人，晚上却变成了温柔体贴的甜心男友。这种反差萌，谁能顶得住啊！',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch1', title: '第1话 新来的小职员', index: 1, updatedAt: '2026-08-04' },
      { id: 'ch2', title: '第2话 社长的秘密', index: 2, updatedAt: '2026-08-01' },
      { id: 'ch3', title: '第3话 加班夜话', index: 3, updatedAt: '2026-07-29' },
      { id: 'ch4', title: '第4话 公司团建', index: 4, updatedAt: '2026-07-26' },
      { id: 'ch5', title: '第5话 前女友出现', index: 5, updatedAt: '2026-07-23' },
      { id: 'ch6', title: '第6话 真心话大冒险', index: 6, updatedAt: '2026-07-20' },
      { id: 'ch7', title: '第7话 告白', index: 7, updatedAt: '2026-07-17' },
    ],
    views: 178900,
    collects: 56300,
    isHot: false,
    isNew: true,
  },
  {
    id: 'yokai-cafe',
    title: '妖怪咖啡厅',
    author: '山田花子',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20fantasy%20slice%20of%20life%20manga%20cover%20featuring%20cozy%20cafe%20interior%20with%20mythical%20Japanese%20yokai%20creatures%20cute%20barista%20characters%20warm%20ambient%20lighting%20whimsical%20atmosphere%20editorial%20illustration%20with%20earthy%20tones%20soft%20glow&width=600&height=800&seq=manga-cover-yc&orientation=portrait',
    category: 'japanese',
    categoryLabel: '日漫',
    rating: 9.8,
    ratingCount: 11230,
    tags: ['奇幻', '治愈', '日常'],
    status: '已完结',
    description: '失业的普通女孩误入一家神秘的咖啡厅，却发现这里的客人全都是妖怪？从最初的恐惧到逐渐融入，她在这家特别的咖啡厅里找到了属于自己的归属。暖心治愈的妖怪日常物语。',
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch1', title: '第1话 迷路的夜晚', index: 1, updatedAt: '2026-06-30' },
      { id: 'ch2', title: '第2话 河童的抹茶拿铁', index: 2, updatedAt: '2026-06-25' },
      { id: 'ch3', title: '第3话 雪女的冰咖啡', index: 3, updatedAt: '2026-06-20' },
      { id: 'ch4', title: '第4话 天狗的黑咖啡', index: 4, updatedAt: '2026-06-15' },
      { id: 'ch5', title: '第5话 猫又的卡布奇诺', index: 5, updatedAt: '2026-06-10' },
      { id: 'ch6', title: '第6话 座敷童子的热可可', index: 6, updatedAt: '2026-06-05' },
      { id: 'ch7', title: '第7话 告别与重逢（终章）', index: 7, updatedAt: '2026-05-30' },
    ],
    views: 98700,
    collects: 38700,
    isHot: false,
    isNew: false,
  },
  {
    id: 'sword-legend',
    title: '剑仙传',
    author: '墨染青衣',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20xianxia%20cultivation%20manga%20cover%20featuring%20elegant%20swordsman%20in%20flowing%20white%20robes%20atop%20misty%20mountain%20peak%20ancient%20Chinese%20fantasy%20setting%20spirit%20swords%20swirling%20energy%20epic%20composition%20editorial%20illustration%20with%20dramatic%20lighting&width=600&height=800&seq=manga-cover-sl&orientation=portrait',
    category: 'chinese',
    categoryLabel: '国漫',
    rating: 9.6,
    ratingCount: 20100,
    tags: ['仙侠', '热血', '冒险'],
    status: '连载中',
    description: '少年凌云从小被遗弃在剑冢，却意外觉醒了上古剑灵。从此踏上修仙之路，御剑飞行、斩妖除魔、问鼎仙道。一剑劈开天地，万古唯有剑仙！热血澎湃的仙侠冒险巨作。',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch1', title: '第1话 剑冢遗孤', index: 1, updatedAt: '2026-08-03' },
      { id: 'ch2', title: '第2话 剑灵觉醒', index: 2, updatedAt: '2026-07-31' },
      { id: 'ch3', title: '第3话 初入宗门', index: 3, updatedAt: '2026-07-28' },
      { id: 'ch4', title: '第4话 炼气试炼', index: 4, updatedAt: '2026-07-25' },
      { id: 'ch5', title: '第5话 妖兽森林', index: 5, updatedAt: '2026-07-22' },
      { id: 'ch6', title: '第6话 筑基丹劫', index: 6, updatedAt: '2026-07-19' },
      { id: 'ch7', title: '第7话 宗门大比', index: 7, updatedAt: '2026-07-16' },
      { id: 'ch8', title: '第8话 金丹悟道', index: 8, updatedAt: '2026-07-13' },
    ],
    views: 256700,
    collects: 91200,
    isHot: true,
    isNew: false,
  },
  {
    id: 'revenge-wedding',
    title: '复仇婚礼',
    author: '姜智雅',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20dramatic%20romance%20manga%20cover%20featuring%20elegant%20bride%20in%20wedding%20dress%20with%20mysterious%20expression%20dark%20undertones%20luxurious%20wedding%20hall%20setting%20Korean%20manhwa%20style%20sophisticated%20atmosphere%20editorial%20illustration%20with%20contrasting%20light%20and%20shadow&width=600&height=800&seq=manga-cover-rw&orientation=portrait',
    category: 'korean',
    categoryLabel: '韩漫',
    rating: 9.4,
    ratingCount: 14560,
    tags: ['复仇', '豪门', '悬疑'],
    status: '连载中',
    description: '她穿上婚纱，不是为了爱情，而是为了复仇。当年害她家破人亡的仇人，如今就站在红毯的另一端。婚礼只是开始，她要让所有人付出代价！',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch1', title: '第1话 血色婚纱', index: 1, updatedAt: '2026-08-01' },
      { id: 'ch2', title: '第2话 面具之下', index: 2, updatedAt: '2026-07-29' },
      { id: 'ch3', title: '第3话 豪门盛宴', index: 3, updatedAt: '2026-07-26' },
      { id: 'ch4', title: '第4话 暗室秘谈', index: 4, updatedAt: '2026-07-23' },
      { id: 'ch5', title: '第5话 意外证人', index: 5, updatedAt: '2026-07-20' },
      { id: 'ch6', title: '第6话 真相浮现', index: 6, updatedAt: '2026-07-17' },
    ],
    views: 167800,
    collects: 52400,
    isHot: false,
    isNew: true,
  },
  {
    id: 'stars-align',
    title: '命中注定的星座',
    author: '星野琉璃',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20astrology%20themed%20romance%20manga%20cover%20featuring%20constellation%20starry%20sky%20background%20two%20characters%20connected%20by%20cosmic%20threads%20zodiac%20symbols%20subtle%20magical%20elements%20dreamy%20atmosphere%20editorial%20illustration%20with%20indigo%20and%20silver%20tones&width=600&height=800&seq=manga-cover-sa&orientation=portrait',
    category: 'japanese',
    categoryLabel: '日漫',
    rating: 9.2,
    ratingCount: 8900,
    tags: ['星座', '恋爱', '命运'],
    status: '连载中',
    description: '占星社的社长天野星，遇见了完全不信任星座的转学生。两个星座相克的人，却在一次次的偶然中被命运拉近。到底是星座在指引他们，还是他们在改写星座的预言？',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch1', title: '第1话 水瓶与狮子', index: 1, updatedAt: '2026-08-02' },
      { id: 'ch2', title: '第2话 占星社的新成员', index: 2, updatedAt: '2026-07-30' },
      { id: 'ch3', title: '第3话 流星雨之夜', index: 3, updatedAt: '2026-07-27' },
      { id: 'ch4', title: '第4话 星座配对', index: 4, updatedAt: '2026-07-24' },
      { id: 'ch5', title: '第5话 双子座的谎言', index: 5, updatedAt: '2026-07-21' },
    ],
    views: 78900,
    collects: 28900,
    isHot: false,
    isNew: true,
  },
  {
    id: 'goddess-descends',
    title: '女神降临',
    author: '喵太郎',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20beauty%20transformation%20manga%20cover%20featuring%20stunning%20female%20protagonist%20with%20glamorous%20makeup%20transformation%20before-after%20theme%20modern%20urban%20setting%20Korean%20manhwa%20beauty%20style%20editorial%20illustration%20with%20soft%20glamorous%20lighting&width=600&height=800&seq=manga-cover-gd&orientation=portrait',
    category: 'korean',
    categoryLabel: '韩漫',
    rating: 9.7,
    ratingCount: 35600,
    tags: ['变身', '校园', '恋爱'],
    status: '连载中',
    description: '从小因为外貌被嘲笑的女主角，通过化妆找到了自信。从不起眼的"丑小鸭"变成全校瞩目的"女神"，她的校园生活从此天翻地覆。但当面具被摘下，真实的她还能被接纳吗？',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch1', title: '第1话 丑小鸭的眼泪', index: 1, updatedAt: '2026-08-04' },
      { id: 'ch2', title: '第2话 化妆的第一步', index: 2, updatedAt: '2026-08-01' },
      { id: 'ch3', title: '第3话 女神的诞生', index: 3, updatedAt: '2026-07-29' },
      { id: 'ch4', title: '第4话 两个校草', index: 4, updatedAt: '2026-07-26' },
      { id: 'ch5', title: '第5话 校园祭的危机', index: 5, updatedAt: '2026-07-23' },
      { id: 'ch6', title: '第6话 素颜曝光', index: 6, updatedAt: '2026-07-20' },
      { id: 'ch7', title: '第7话 真正的女神', index: 7, updatedAt: '2026-07-17' },
      { id: 'ch8', title: '第8话 爱与勇气', index: 8, updatedAt: '2026-07-14' },
      { id: 'ch9', title: '第9话 告白时刻', index: 9, updatedAt: '2026-07-11' },
    ],
    views: 456200,
    collects: 152300,
    isHot: true,
    isNew: false,
  },
  {
    id: 'phoenix-painting',
    title: '凤凰于飞',
    author: '水墨丹青',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20Chinese%20mythology%20manga%20cover%20featuring%20majestic%20phoenix%20bird%20in%20flight%20vibrant%20red%20and%20gold%20feathers%20ancient%20palace%20courtyard%20background%20ethereal%20beauty%20traditional%20Chinese%20painting%20aesthetics%20editorial%20illustration%20with%20dramatic%20composition&width=600&height=800&seq=manga-cover-pp&orientation=portrait',
    category: 'chinese',
    categoryLabel: '国漫',
    rating: 9.5,
    ratingCount: 13400,
    tags: ['神话', '爱情', '古风'],
    status: '已完结',
    description: '她是凤凰一族的最后血脉，他是人间最尊贵的帝王。一场跨越三界的禁忌之恋，在神魔大战的背景下徐徐展开。当天下苍生与儿女情长难以两全，她会做出怎样的选择？',
    updatedAt: '2026-06-15',
    chapters: [
      { id: 'ch1', title: '第1话 凤鸣岐山', index: 1, updatedAt: '2026-06-15' },
      { id: 'ch2', title: '第2话 人间帝王', index: 2, updatedAt: '2026-06-10' },
      { id: 'ch3', title: '第3话 九天玄女', index: 3, updatedAt: '2026-06-05' },
      { id: 'ch4', title: '第4话 瑶池宴', index: 4, updatedAt: '2026-05-30' },
      { id: 'ch5', title: '第5话 情劫', index: 5, updatedAt: '2026-05-25' },
      { id: 'ch6', title: '第6话 浴火重生（终章）', index: 6, updatedAt: '2026-05-20' },
    ],
    views: 145600,
    collects: 52300,
    isHot: false,
    isNew: false,
  },
  {
    id: 'wind-whisper',
    title: '听见风的声音',
    author: '松本夏实',
    coverUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20emotional%20slice%20of%20life%20manga%20cover%20featuring%20girl%20standing%20in%20wind%20swept%20field%20golden%20hour%20lighting%20flowing%20hair%20and%20clothes%20nostalgic%20atmosphere%20rural%20Japanese%20countryside%20setting%20editorial%20illustration%20with%20warm%20nostalgic%20tones&width=600&height=800&seq=manga-cover-ww&orientation=portrait',
    category: 'japanese',
    categoryLabel: '日漫',
    rating: 9.3,
    ratingCount: 7650,
    tags: ['治愈', '成长', '文艺'],
    status: '已完结',
    description: '失聪少女在转学到乡下后，遇到了一个能用"心"与她交流的男孩。在那个充满风声的小镇上，她第一次"听到"了世界的美好。一部关于成长、友情与自我接纳的温暖物语。',
    updatedAt: '2026-05-30',
    chapters: [
      { id: 'ch1', title: '第1话 寂静的世界', index: 1, updatedAt: '2026-05-30' },
      { id: 'ch2', title: '第2话 转学生', index: 2, updatedAt: '2026-05-25' },
      { id: 'ch3', title: '第3话 手语与心语', index: 3, updatedAt: '2026-05-20' },
      { id: 'ch4', title: '第4话 夏日祭', index: 4, updatedAt: '2026-05-15' },
      { id: 'ch5', title: '第5话 风的声音（终章）', index: 5, updatedAt: '2026-05-10' },
    ],
    views: 67800,
    collects: 25400,
    isHot: false,
    isNew: false,
  },
];

export const rankings = {
  popularity: [...mangaList].sort((a, b) => b.views - a.views).slice(0, 10),
  newArrivals: [...mangaList].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 10),
  collections: [...mangaList].sort((a, b) => b.collects - a.collects).slice(0, 10),
};

export const aboutInfo = {
  brandName: '女神漫画',
  slogan: '女神漫画 — 让每一页都成为心动瞬间',
  introduction: '女神漫画成立于2020年，是国内领先的女性向漫画阅读平台。我们专注于为漫画爱好者提供优质的韩漫、日漫、国漫内容，致力于打造一个温馨、便捷、高品质的在线阅读社区。',
  story: '由一群热爱漫画的年轻人创立，女神漫画的初心很简单——让每一位读者都能在这里找到属于自己的心动故事。从最初的几十部作品到如今收录上千部优质漫画，我们始终坚持以用户为中心，不断优化阅读体验。',
  mission: '汇聚全球优质漫画资源，为中文读者提供最便捷、最舒适的在线阅读体验。',
  vision: '成为华语世界最受欢迎的女性向漫画平台。',
  values: ['用户至上 — 一切以读者体验为核心', '内容为王 — 精选优质漫画，宁缺毋滥', '创新驱动 — 持续优化产品，引领行业标准', '社区共建 — 打造温暖有爱的漫画交流社区'],
  achievements: [
    { number: '1000+', label: '收录漫画' },
    { number: '500万+', label: '月活用户' },
    { number: '99.8%', label: '用户满意度' },
    { number: '200+', label: '合作作者' },
  ],
  testimonials: [
    { name: '小樱花', role: '资深漫迷', content: '女神漫画是我用过最好的漫画阅读平台！界面简洁漂亮，加载速度超快，分类也很清晰。每天睡前必刷！' },
    { name: '漫画狂热者', role: '漫画博主', content: '作为一个漫画博主，女神漫画的漫画推荐功能真的太棒了。总能发现新的宝藏漫画，韩漫日漫国漫一网打尽！' },
    { name: '星星点灯', role: '大学生', content: '下拉式阅读体验太丝滑了，追更提醒也很贴心。已经推荐给了身边所有爱看漫画的朋友！' },
  ],
  contact: {
    email: 'contact@goddessmanga.com',
    wechat: '女神漫画官方',
    weibo: '@女神漫画',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    phone: '400-888-6666',
  },
  faq: [
    { question: '女神漫画是免费的吗？', answer: '是的，女神漫画平台上的所有漫画内容均免费提供阅读。我们致力于让每一位喜爱漫画的读者都能无障碍地享受阅读乐趣。' },
    { question: '如何追更喜欢的漫画？', answer: '您可以通过我们的追更功能订阅感兴趣的漫画。当漫画有更新时，您会第一时间收到通知提醒，不错过任何精彩内容。' },
    { question: '支持哪些设备阅读？', answer: '女神漫画支持PC端网页、手机端网页以及平板设备，采用响应式设计，在不同设备上都能获得流畅的阅读体验。' },
    { question: '漫画更新频率是怎样的？', answer: '热门连载漫画通常保持每周1-2话的更新频率。具体更新时间请关注每部漫画的详情页面，上面会标注最新的更新时间。' },
    { question: '可以下载漫画离线阅读吗？', answer: '目前女神漫画支持在线下拉式阅读，下载功能正在开发中，敬请期待！' },
  ],
};

export const hotTags = ['恋爱', '逆袭', '古风', '校园', '奇幻', '仙侠', '甜宠', '复仇', '治愈', '纯爱', '搞笑', '悬疑'];

export const bannerSlides = [
  {
    id: 'banner-1',
    title: '女神漫画',
    subtitle: '韩漫日漫国漫全集免费推荐',
    description: '排行榜热门精选 · 下拉式在线漫画阅读 · 追更收藏大全',
    imageUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20elegant%20manga%20website%20hero%20banner%20featuring%20beautiful%20female%20characters%20from%20romance%20fantasy%20historical%20genres%20soft%20pink%20and%20gold%20tones%20dreamy%20atmosphere%20artistic%20composition%20editorial%20illustration%20with%20cherry%20blossoms%20and%20sparkles%20wide%20cinematic%20layout&width=1600&height=900&seq=banner-hero-01&orientation=landscape',
  },
  {
    id: 'banner-2',
    title: '热门韩漫推荐',
    subtitle: '浪漫宫廷 · 职场甜宠 · 逆袭复仇',
    description: '精选韩国优质漫画，沉浸式下拉阅读体验',
    imageUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20Korean%20manhwa%20themed%20banner%20featuring%20elegant%20characters%20in%20historical%20and%20modern%20settings%20soft%20romantic%20atmosphere%20with%20warm%20lighting%20Korean%20aesthetic%20pastel%20color%20palette%20artistic%20editorial%20illustration%20with%20flowing%20composition&width=1600&height=900&seq=banner-hero-02&orientation=landscape',
  },
  {
    id: 'banner-3',
    title: '国漫崛起',
    subtitle: '古风仙侠 · 原创国风 · 神话传奇',
    description: '支持国产原创漫画，发现国漫之美',
    imageUrl: 'https://readdy.ai/api/search-image?query=anime%20style%20Chinese%20manhua%20themed%20banner%20featuring%20characters%20in%20traditional%20Chinese%20hanfu%20with%20xianxia%20fantasy%20elements%20ink%20wash%20painting%20aesthetics%20flowing%20ink%20and%20mist%20artistic%20composition%20vermillion%20and%20gold%20tones%20with%20ethereal%20lighting%20editorial%20illustration&width=1600&height=900&seq=banner-hero-03&orientation=landscape',
  },
];